module.exports = __webpack_public_path__ + "static/media/Half_White_ADFA-logo.ba6cdd9d.svg";